import axios from 'axios'
import { makeQueryString } from '@/utils/Query.js'
const API_BASE_URL = process.env.VUE_APP_API_URL;

const config = {
    baseUrl: API_BASE_URL + "/homepage/instore/"
};

const instoreAPIDFN = {
    instoreAPI: (APIName, conditions, paths) => {
        return instoreAPI[APIName](conditions, paths);
    }
};

const instoreAPI = {
    API_BASE_URL: `${API_BASE_URL}`,
    selectInstoreNotice: (conditions, paths) => {
        const uri = paths || "instore/selectInstoreNotice"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    getInstoreNotice: (conditions, paths) => {
        const uri = paths || "instore/getInstoreNotice"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    updateInstoreNoticeQryCnt: (conditions, paths) => {
        const uri = paths || "instore/updateInstoreNoticeQryCnt"
        return axios.post(`${config.baseUrl}${uri}`, conditions);
    },
    selectInstoreFaq: (conditions, paths) => {
        const uri = paths || "instore/selectInstoreFaq"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    getInstoreFaq: (conditions, paths) => {
        const uri = paths || "instore/getInstoreFaq"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    selectInstoreProductCategory: (conditions, paths) => {
        const uri = paths || "instore/selectInstoreProductCategory"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    insertInstoreConsultationRequest: (conditions, paths) => {
        const uri = paths || "instore/insertInstoreConsultationRequest"
        return axios.post(`${config.baseUrl}${uri}`, conditions);
    },
    insertInstoreCompany: (conditions, paths) => {
        const uri = paths || "instore/insertInstoreCompany"
        return axios.post(`${config.baseUrl}${uri}`, conditions);
    },
};

export { instoreAPIDFN, instoreAPI };
